module.exports = __webpack_public_path__ + "static/media/match-visualization.1096a314.svg";